import {PartialGameViewModel} from "../../../domain/partial-game/models/partial-game-view-model";
import {computed} from "mobx";
import {OddsViewModel} from "../../../domain/common/odds/models/odds.view-model";

export class PreviousMeetingsWidgetPartialGameViewModel extends PartialGameViewModel {

  get topText(): String {
    return this.competition.name;
  }

  get bottomText(): String {
    return this.date;
  }

  get scoreTimeText(): String {
    let scoreTimeText: String = this.homeCompetitor.score + ' - ' + this.awayCompetitor.score;

    if(this.isScheduled) {
      scoreTimeText = this.time;
    }

    return scoreTimeText;
  }

  @computed get odds(): OddsViewModel {
    if (!this.domainModel.odds) {
      return null;
    }

    const odds: OddsViewModel = new OddsViewModel(this.domainModel.odds, this.oddsType);

    return odds;
  }


  @computed get hasOdds(): Boolean {
    return this.odds || this.oddsPreview;
  }

  @computed get hasCurrentValidRates(): Boolean {
    let hasValidRates: Boolean = this.odds?.isValidCurrentRateOptions || this.oddsPreview?.cellsRates?.length > 0

    return hasValidRates;
  }

  @computed get shouldRenderOdds(): Boolean {
    return this.hasOdds;
  }
}
